import { components } from 'react-select';

const CountriesNoOptionsMessageTemplate = (props) => (
  <components.NoOptionsMessage {...props}>
    {props.selectProps.search?.trim()?.length > 0
      ? props.selectProps.emptySearchMessage
      : props.selectProps.emptyOptionsMessage}
  </components.NoOptionsMessage>
);
export default CountriesNoOptionsMessageTemplate;
